import iDizaynZavod from "../../../assets/icons/Dizayn zavod.svg";
import iTelegram from "../../../assets/icons/telegram.svg";
import ContactsItem from "./contacts-item";
import "./contacts-list.sass";

const ContactsList = () => {
  return (
    <div className="contacts-list">
      <div className="contacts-list__list">
        <ContactsItem
          title="Офис в Москве"
          className="contacts-list__item_office"
        >
          Дизайн-завод
          <br />
          <a
            href="https://yandex.ru/maps/?text=Москва%2C%20ул.%20Большая%20Новодмитровская%2C%2036%20стр.%202"
            target="_blank"
            rel="noreferrer"
            className="link"
          >
            Москва, ул. Большая Новодмитровская, 36 стр. 2
          </a>
        </ContactsItem>

        <ContactsItem
          title="Ресепшен"
          className="contacts-list__item_reception"
        >
          <a href="tel:+74950322255" className="contacts-list__phone-link">
            +7&nbsp;(495)&nbsp;032-22-55
          </a>
          <br />
          <a href="mailto:info@creon-cg.com" className="link">
            info@creon-cg.com
          </a>
        </ContactsItem>

        <ContactsItem
          title="Приглашение в тендер и новые брифы"
          className="contacts-list__item_briefs"
        >
          Воронова Анастасия
          <br />
          Менеджер по новому бизнесу
          <br />
          <a href="mailto:voronova@creon-cg.com" className="link">
            voronova@creon-cg.com
          </a>
        </ContactsItem>

        <ContactsItem
          title="Мы в соцсетях"
          className="contacts-list__item_social"
        >
          <a href="https://t.me/creoncg" target="_blank" rel="noreferrer">
            <img src={iTelegram} alt="" />
          </a>
        </ContactsItem>

        <ContactsItem
          title="Мы резиденты"
          className="contacts-list__item_resident"
        >
          <a
            href="https://design-zavod.ru/people/creon"
            target="_blank"
            rel="noreferrer"
            className="contacts-list__resident-link"
            aria-label="Страница CREON на сайте Дизайн-завода"
          >
            <img
              src={iDizaynZavod}
              alt="Дизайн-завод"
              className="contacts-list__resident-logo"
            />
          </a>
        </ContactsItem>
      </div>
    </div>
  );
};

export default ContactsList;
